
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/pharmaceutical/products/drug-formulation-and-manufacturing-process-optimization-software",
      function () {
        return require("private-next-pages/industries/pharmaceutical/products/drug-formulation-and-manufacturing-process-optimization-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/pharmaceutical/products/drug-formulation-and-manufacturing-process-optimization-software"])
      });
    }
  